import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 50 50" {...props}>
      <defs>
        <clipPath id="prefix__a">
          <path d="M0 0h50v50H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefix__a)">
        <rect
          data-name="Rectangle 734"
          width={48}
          height={47.5}
          rx={2}
          fill={props.fillPrimary}
          transform="translate(1 1)"
        />
        <g data-name="Group 2563" fill={props.fillSecondary}>
          <g data-name="Group 1852">
            <path data-name="Rectangle 741" d="M23.652 30.704h2.698v6.361h-2.698z" />
            <path
              data-name="Path 5398"
              d="M15.082 8.638v7.957a17.755 17.755 0 007.225 14.3L25 32.88l2.694-1.985a17.754 17.754 0 007.224-14.3V8.638z"
            />
          </g>
          <path
            data-name="Path 5399"
            d="M35.648 10H14.354a.561.561 0 01-.562-.561v-1.6a.561.561 0 01.562-.561h21.294a.561.561 0 01.562.561v1.6a.561.561 0 01-.562.561z"
          />
          <path
            data-name="Path 5400"
            d="M35.647 7.275h-3.168V10h3.168a.561.561 0 00.562-.561v-1.6a.561.561 0 00-.562-.564z"
          />
          <path
            data-name="Path 5401"
            d="M25.113 14.678l1.409 2.855a.127.127 0 00.094.068l3.151.458a.123.123 0 01.068.211l-2.281 2.223a.129.129 0 00-.035.111l.538 3.138a.124.124 0 01-.18.131l-2.819-1.482a.125.125 0 00-.116 0l-2.819 1.482a.124.124 0 01-.18-.131l.538-3.138a.125.125 0 00-.035-.111l-2.28-2.223a.124.124 0 01.069-.211l3.151-.458a.121.121 0 00.093-.068l1.41-2.855a.124.124 0 01.224 0z"
            opacity={0.2}
          />
          <g data-name="Group 1853">
            <path
              data-name="Path 5402"
              d="M26.53 33.826h-3.062a1.039 1.039 0 01-1.039-1.039v-.449a1.039 1.039 0 011.039-1.039h3.062a1.039 1.039 0 011.039 1.039v.449a1.039 1.039 0 01-1.039 1.039z"
            />
            <path
              data-name="Path 5403"
              d="M30.264 38.882H19.739v-2.239a1.4 1.4 0 011.4-1.4h7.731a1.4 1.4 0 011.4 1.4z"
            />
          </g>
          <g data-name="Group 1854">
            <path
              data-name="Path 5404"
              d="M28.866 35.246h-2.315v3.636h3.716v-2.239a1.4 1.4 0 00-1.401-1.397z"
            />
            <path
              data-name="Path 5405"
              d="M33.202 42.547h-16.4a.779.779 0 01-.765-.928l.588-3.006a.778.778 0 01.764-.63h15.225a.78.78 0 01.765.63l.588 3.006a.779.779 0 01-.765.928z"
            />
          </g>
          <path
            data-name="Path 5406"
            d="M33.966 41.62l-.588-3.006a.779.779 0 00-.764-.63h-3.13l.893 4.564h2.825a.779.779 0 00.764-.928z"
          />
          <path
            data-name="Path 5407"
            d="M42.064 10.053a1.864 1.864 0 00-1.323-.547 4.249 4.249 0 00-3.486 1.836l-.483.7a1.462 1.462 0 01-1.2.631h-.025v-2.054h.107a1.184 1.184 0 001.184-1.183v-1.6a1.185 1.185 0 00-1.19-1.183H14.357a1.185 1.185 0 00-1.184 1.183v1.6a1.184 1.184 0 001.184 1.183h.107v2.054h-.025a1.462 1.462 0 01-1.2-.631l-.484-.7a4.248 4.248 0 00-3.484-1.836 1.872 1.872 0 00-1.878 1.873v2.6c0 6.221 3.193 7.518 5.759 8.559 1.438.584 2.681 1.088 3.279 2.32a.753.753 0 01-.111.92 1.214 1.214 0 01-1.249.3c-.444-.19-.514-.744-.495-1.178a.622.622 0 10-1.242-.057 2.35 2.35 0 001.247 2.378 2.16 2.16 0 00.848.167 2.5 2.5 0 001.789-.756 1.966 1.966 0 00.138-.161 18.325 18.325 0 004.586 4.917l.115.085a1.645 1.645 0 00-.245.862v.449a1.663 1.663 0 001.222 1.6v.239h-1.9a2.02 2.02 0 00-2.019 2.018v.719h-1.728a1.4 1.4 0 00-1.375 1.133l-.588 3.006a1.4 1.4 0 001.375 1.669h16.4a1.4 1.4 0 001.375-1.669l-.588-3.006a1.4 1.4 0 00-1.375-1.133h-1.728v-.719a2.021 2.021 0 00-2.019-2.019h-1.9v-.238a1.663 1.663 0 001.22-1.6v-.449a1.644 1.644 0 00-.244-.862l.115-.085a18.341 18.341 0 004.585-4.917c.044.055.088.11.138.161a2.507 2.507 0 001.789.756 2.159 2.159 0 00.848-.167 2.348 2.348 0 001.247-2.378.622.622 0 10-1.242.057c.02.434-.049.988-.495 1.178a1.214 1.214 0 01-1.248-.3.751.751 0 01-.109-.919c.6-1.233 1.84-1.738 3.279-2.322 2.566-1.041 5.758-2.338 5.758-8.559v-2.6a1.854 1.854 0 00-.541-1.325zM13.615 21.385a8.716 8.716 0 01-3.415-2.044c-1.055-1.177-1.568-2.931-1.568-5.363v-2.6a.629.629 0 01.629-.629 3.006 3.006 0 012.465 1.3l.483.7a2.7 2.7 0 002.226 1.169h.025v2.675a18.31 18.31 0 00.869 5.561 17.814 17.814 0 00-1.714-.768zm15.252 14.483a.777.777 0 01.776.775v.719h-5.527a.622.622 0 000 1.244h8.5a.156.156 0 01.154.127l.588 3.006a.156.156 0 01-.033.131.153.153 0 01-.121.058h-16.4a.153.153 0 01-.121-.058.155.155 0 01-.033-.131l.587-3.006a.159.159 0 01.155-.127h3.834a.622.622 0 000-1.244h-.869v-.719a.777.777 0 01.776-.775zm-5.4-2.664a.418.418 0 01-.417-.417v-.449a.418.418 0 01.417-.418h3.061a.418.418 0 01.417.418v.449a.418.418 0 01-.417.417zm2.258 1.244v.177H24.27v-.177zm8.57-17.854a17.2 17.2 0 01-6.972 13.8l-.442.326a1.655 1.655 0 00-.352-.039h-3.061a1.648 1.648 0 00-.352.039l-.442-.326a17.2 17.2 0 01-6.972-13.8v-5.972h11.659a.622.622 0 000-1.243h-12.95V7.896h21.175v1.483h-5.329a.622.622 0 100 1.243H34.3v5.972zm7.072-2.615c0 2.432-.512 4.186-1.568 5.363a8.718 8.718 0 01-3.415 2.044 17.81 17.81 0 00-1.716.769 18.31 18.31 0 00.869-5.56v-2.676h.025a2.705 2.705 0 002.226-1.169l.483-.7a3 3 0 012.466-1.3.629.629 0 01.63.629v2.6z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
